<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import type { VerifyCustomerRow, VerifyCustomerDraft } from "../../contract"
  import { ContactComparisonTag } from "../../../../../../_shared/_modules/contact-comparison-tag"
  import { comparison, previousComparisons } from "../../_shared/_logic/comparison"
  let { row, draft, columnConfig }: InboxWorkflowCellProps<VerifyCustomerRow, VerifyCustomerDraft> =
    $props()
</script>
{#if columnConfig.id === "existingCustomers"}
  <div class="comparison-stack"
    >{#each previousComparisons(row) as value}<ContactComparisonTag {value} />{/each}</div
  >
{:else}<ContactComparisonTag value={comparison(row, draft)} />{/if}
<style>
  .comparison-stack {
    display: grid;
    gap: 0.35rem;
  }
</style>
